import { getAdminBusinessId, getUserBusinesses } from "./authHelper";

export const PAYMENT_INTEGRATIONS_PATH = "/integrations?tab=payments";
export const PAYMENT_INTEGRATION_REQUIRED_MESSAGE =
  "Connect Stripe or PayPal before creating a paid event.";

export const resolvePaymentIntegrationBusinessId = () => {
  const stored = getAdminBusinessId();
  if (stored) {
    return stored;
  }
  const businesses = getUserBusinesses();
  if (Array.isArray(businesses) && businesses.length > 0) {
    return businesses[0].id || businesses[0].business_id || null;
  }
  return null;
};

export const parseHasPaymentIntegration = (payload) => {
  const body = payload?.data ?? payload ?? {};
  const nested = body.data ?? body;
  return nested.has_payment_integration === true;
};
